import * as z from 'zod'

import {
  validateEmail,
  validateName,
  validatePhone
} from '@stone-ton/validaton'

interface ValidateArgs {
  value: string
  ctx: z.RefinementCtx
  validator(value: string): string | boolean
}

function isValid({ ctx, value, validator }: ValidateArgs) {
  const message = validator(value)

  if (typeof message === 'boolean') {
    return true
  }

  ctx.addIssue({
    fatal: true,
    message: message,
    code: z.ZodIssueCode.custom
  })

  return false
}

const required_error = 'Campo obrigatório'

export const schema = z.object({
  name: z
    .string({
      required_error
    })
    .superRefine((value, ctx) => {
      const isValidFullName = isValid({
        ctx,
        value,
        validator: validateName
      })

      if (!isValidFullName) {
        return z.NEVER
      }
    }),
  email: z
    .string({
      required_error
    })
    .superRefine((value, ctx) => {
      const isValidEmail = isValid({
        ctx,
        value,
        validator: validateEmail
      })

      if (!isValidEmail) {
        return z.NEVER
      }
    }),
  phone: z
    .string({
      required_error
    })
    .superRefine((value, ctx) => {
      const isValidPhone = isValid({
        ctx,
        value,
        validator: validatePhone
      })

      if (!isValidPhone) {
        return z.NEVER
      }
    })
})
